<script lang="ts" context="module">
  // TODO: Remove DEPRECATED blocks when not in use in storyblok
  const map = {
    'categories-cross-sell': CategoriesCrossSell, // DEPRECATED
    'product-detail': ProductDetail,
    'shop-the-look-section': ShopTheLook, // DEPRECATED
    hero: Hero, // DEPRECATED
    'text-with-image': TextWithImage, // DEPRECATED
    'products-showcase': ProductsShowcase, // DEPRECATED
    'products-showcase-with-links': ProductsShowcaseWithLinks,
    'styled-by-you-section': StyledByYouSection,
    'synced-block': SyncedBlock,
    recommendations: Recommendations, // DEPRECATED
    'recently-viewed': RecentlyViewed,
    'regional-content': RegionalContent,
    image: Image, // DEPRECATED
    testimonial: Testimonial, // DEPRECATED
    'detailed-testimonial': DetailedTestimonial, // DEPRECATED
    contact: Contact,
    'contact-list': ContactList,
    info: InfoBlock, // DEPRECATED
    heading: Heading, // DEPRECATED
    'collection-card': CollectionCard, // DEPRECATED
    'two-images': TwoImages, // DEPRECATED
    cover: CoverBlock, // DEPRECATED
    'product-highlight': ProductHighlight, // DEPRECATED
    game: Game,
    'image-video': ImageVideoBlock, // DEPRECATED
    'info-block-image': InfoBlockImage, // DEPRECATED
    'four-products': FourProducts, // DEPRECATED
    'section-title': SectionTitle, // DEPRECATED
    'html-block': HtmlBlock,
    'paralax-masonry': ParalaxMasonry,
    'title-section': TitleSection,
    'hero-section': HeroSection,
    'centered-text-section': CenteredTextSection,
    'left-aligned-text-section': LeftAlignedTextSection,
    'bottom-section': BottomSection,
    reviews: Reviews, // DEPRECATED
    avatar: Avatar,
    'shop-the-look-index': ShopTheLookIndex,
    'ring-sizer': RingSizer,
    'styled-by-you-index': StyledByYouIndex,
    'sales-hero': SalesHero,
    logos: Logos,
    'ab-test-content': AbTestContent,
    'media-grid': MediaGrid
  };

  export type Bloks = keyof typeof map;

  const isComponent = (block: { component: string }): block is { component: Bloks } => {
    return !!block.component && block.component in map;
  };
</script>

<script lang="ts">
  import { dev } from '$app/environment';
  import type { ComponentType } from 'svelte';

  import CategoriesCrossSell from './deprecated/categories-cross-sell.svelte';
  import ProductDetail from './product-detail.svelte';
  import ShopTheLook from './deprecated/shop-the-look-section.svelte';
  import Hero from './deprecated/hero.svelte';
  import TextWithImage from './deprecated/text-with-image.svelte';
  import ProductsShowcase from './deprecated/products-showcase.svelte';
  import ProductsShowcaseWithLinks from './products-showcase-with-links.svelte';
  import StyledByYouSection from './styled-by-you-section.svelte';
  import SyncedBlock from './synced-block.svelte';
  import Recommendations from './deprecated/recommendations.svelte';
  import RecentlyViewed from './recently-viewed.svelte';
  import RegionalContent from './regional-content.svelte';
  import Contact from './contact.svelte';
  import ContactList from './contact-list.svelte';
  import Testimonial from './deprecated/testimonial-block.svelte';
  import CoverBlock from './cover-block.svelte';
  import InfoBlock from './deprecated/info-block.svelte';
  import Heading from './deprecated/heading.svelte';
  import CollectionCard from './deprecated/collection-card.svelte';
  import TwoImages from './deprecated/two-images.svelte';
  import Image from './deprecated/image-video-block.svelte';
  import DetailedTestimonial from './deprecated/detailed-testimonial.svelte';
  import ProductHighlight from './deprecated/product-highlight.svelte';
  import Game from './game/game-block.svelte';
  import ImageVideoBlock from './deprecated/image-video-block.svelte';
  import InfoBlockImage from './deprecated/info-block-image.svelte';
  import FourProducts from './deprecated/four-products.svelte';
  import RingSizer from './ring-sizer.svelte';
  import SectionTitle from '$components/section-title.svelte';
  import HtmlBlock from './html-block.svelte';
  import ParalaxMasonry from './paralax-masonry.svelte';
  import TitleSection from './title-section.svelte';
  import HeroSection from './hero-section.svelte';
  import CenteredTextSection from './centered-text-section.svelte';
  import LeftAlignedTextSection from './left-aligned-text-section.svelte';
  import BottomSection from './bottom-section.svelte';
  import Reviews from './deprecated/reviews.svelte';
  import Avatar from '$components/avatar.svelte';
  import ShopTheLookIndex from './shop-the-look-index.svelte';
  import StyledByYouIndex from './styled-by-you-index.svelte';
  import Logos from './logos.svelte';
  import SalesHero from './sales-hero.svelte';
  import AbTestContent from './ab-test-content.svelte';
  import MediaGrid from './media-grid.svelte';

  export let block: { component: string };

  const component: ComponentType | null = isComponent(block) ? map[block.component] : null;

  if (!component && dev) {
    console.error('Uncaught component', block.component);
  }
</script>

{#if component}
  <svelte:component this={component} {block} {...$$restProps} />
{/if}
